import React from "react";
import { BillingCreateNavigation } from "~/components/common/constructions/navigation/BillingCreateNavigation";
import { ConstructionClientNavigation } from "~/components/common/constructions/navigation/ConstructionClientNavigation";
import { EstimationHistoryNavigation } from "~/components/common/constructions/navigation/EstimationHistoryNavigation";
import { useDealBillings } from "~/hooks/deals/useDealBillings";
import { useDealEstimationHeaders } from "~/hooks/deals/useDealEstimationHeaders";
import { useDealEstimations } from "~/hooks/deals/useDealEstimations";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import type { Deal } from "~/models/Deal";
import { ESTIMATION_BY } from "~/models/Deal";
import { IN_ESTIMATION, isOwnStatus, SEND_ESTIMATE } from "~/models/Status";
import { PATH } from "~/pages/deals/[id]/deal_estimation_headers/[headerId]/index";

type Props = {
	deal: Deal;
};

export function EstimationClientPanel({ deal }: Props) {
	const id = useIdQueryHandler();
	const { data: estimationContext } = useDealEstimations().index(id);
	const { data: dealEstimationHeaders } = useDealEstimationHeaders().index(id);
	const { data: ownerBillingContext, mutate: mutateOwnerBillings } =
		useDealBillings().index(id, "owner");
	const { data: renteeBillingContext, mutate: mutateRenteeBillings } =
		useDealBillings().index(id, "rentee");
	const mutateBillings = React.useCallback(async () => {
		await mutateOwnerBillings?.();
		await mutateRenteeBillings?.();
	}, [mutateOwnerBillings, mutateRenteeBillings]);
	if (
		id === null ||
		estimationContext === null ||
		ownerBillingContext === null ||
		renteeBillingContext === null ||
		dealEstimationHeaders === null
	) {
		return null;
	}

	const showEstimationNavigation =
		(deal.estimationBy === ESTIMATION_BY.COMPANY &&
			deal.statusId >= IN_ESTIMATION) ||
		(deal.estimationBy === ESTIMATION_BY.VENDOR &&
			deal.statusId >= SEND_ESTIMATE);
	if (!showEstimationNavigation) return null;

	return (
		<div>
			<ConstructionClientNavigation title="工事見積書" />
			{deal.statusId >= SEND_ESTIMATE && (
				<BillingCreateNavigation
					deal={deal}
					estimationContext={estimationContext}
					mutateBillings={mutateBillings}
					ownerBillingContext={ownerBillingContext}
					renteeBillingContext={renteeBillingContext}
					title="工事請求書"
				/>
			)}
			<EstimationHistoryNavigation
				dealEstimationHeaders={dealEstimationHeaders}
				detailPagePath={(headerId: number): string => PATH(id, headerId)}
				ownManagement={isOwnStatus(deal.statusId)}
			/>
		</div>
	);
}
